import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DETAILS_LAYOUT from "../../components/layout/DetailsLayout.component";
import {
  useGetPackageDetailsQuery,
  useGetPackageNotificationsQuery,
  useGetProjectDetailsQuery,
  useGetProjectPackagesQuery,
} from "../../state-management/hooks";
import { IViewProps } from "../View.types";
import { Col } from "react-bootstrap";
import PACKAGE_SELECTOR from "../../components/card/PackageSelector/PackageSelector.component";
import {
  GetProjectDetailsResponse,
  GetProjectPackagesResponse,
} from "../../api/models";
import useQuery from "../../shared/hooks/useQuery";
import PACKAGE_DETAILS_CARD from "../../components/card/DetailsCard/PackageDetailsCard.component";
import NOTIFICATIONS_CARD from "../../components/card/NotificationsCard/NotificationsCard.component";
import { IDataSubscription } from "../../components/card/Card.types";

import AppMedia from "../../theme/utils/AppMedia";
import PACKAGE_SELECTOR_MODAL from "../../components/card/PackageSelector/popout-component/PackageSelectorModal.component";
import { useSelector } from "react-redux";
import { RootState } from "../../state-management/root-reducer";
import { setIsPackageSelectorModalOpen } from "../../state-management/slices/packageSelector/package-selector.slice";
import { useAppDispatch } from "../../state-management/store";
import { useErrorHandling } from "../../shared/utils/errorHandling.utils";

const { Media } = AppMedia;

const DETAILS_VIEW: React.FC<IViewProps> = () => {
  const dispatch = useAppDispatch();
  const query = useQuery();
  const { projectId }: { projectId: string } = useParams();
  const packageId = query.get("packageId") || "";

  // APP STATE
  const { isPackageSelectorModalOpen } = useSelector(
    (state: RootState) => state.packageSelector
  );

  // LOCAL STATE
  const [projectDetails, setProjectDetails] =
    useState<GetProjectDetailsResponse>();

  // DATA
  const projectPackagesSubscription: IDataSubscription<GetProjectPackagesResponse> =
    useGetProjectPackagesQuery({ projectId });

  const packageDetailsSubscription = useGetPackageDetailsQuery({
    projectId,
    packageId,
  });

  const packageNotificationsSubscription = useGetPackageNotificationsQuery({
    projectId,
    packageId,
  });

  const projectDetailsSubscription = useGetProjectDetailsQuery({
    projectId,
  });

  useEffect(() => {
    if (projectDetailsSubscription && projectDetailsSubscription.data) {
      setProjectDetails(projectDetailsSubscription.data);
    }
  }, [projectDetailsSubscription]);

  useErrorHandling(
    projectPackagesSubscription.isError,
    projectPackagesSubscription.error
  );
  useErrorHandling(
    packageDetailsSubscription.isError,
    packageDetailsSubscription.error
  );
  useErrorHandling(
    packageNotificationsSubscription.isError,
    packageNotificationsSubscription.error
  );
  useErrorHandling(
    projectDetailsSubscription.isError,
    projectDetailsSubscription.error
  );

  return (
    <>
      <Media greaterThanOrEqual="tablet">
        <DETAILS_LAYOUT title={projectDetails?.projectTitle}>
          <Col xs="4">
            <PACKAGE_SELECTOR subscription={projectPackagesSubscription} />
          </Col>
          <Col xs="8">
            <PACKAGE_DETAILS_CARD
              subscription={packageDetailsSubscription}
              projectSubscription={projectDetailsSubscription}
            />
            <NOTIFICATIONS_CARD
              subscription={packageNotificationsSubscription}
            />
          </Col>
        </DETAILS_LAYOUT>
      </Media>

      <Media lessThan="tablet">
        <DETAILS_LAYOUT title={projectDetails?.projectTitle}>
          <PACKAGE_SELECTOR subscription={projectPackagesSubscription} />
          <PACKAGE_DETAILS_CARD
            subscription={packageDetailsSubscription}
            projectSubscription={projectDetailsSubscription}
          />
          <NOTIFICATIONS_CARD subscription={packageNotificationsSubscription} />
        </DETAILS_LAYOUT>

        <PACKAGE_SELECTOR_MODAL
          subscription={projectPackagesSubscription}
          show={isPackageSelectorModalOpen}
          handleClose={() => {
            dispatch(setIsPackageSelectorModalOpen(false));
          }}
        />
      </Media>
    </>
  );
};

export default DETAILS_VIEW;
